module.exports = __webpack_public_path__ + "img/person.b9838bf7.jpeg";